/* eslint-disable angular/no-service-method */

angular.
module("dx.webapp.api").
service("dxApiLegacyMasterTools", function masterToolsService(
	$http,

	Raven
) {
	"use strict";

	function info(email, fromNodeId, toNodeId) {
		return $http.post("/mastertools/moveuserdata/info", {
			email: email,
			fromNodeId: fromNodeId,
			toNodeId: toNodeId,
		}).then(resolveRes);
	}

	function perform(email, fromNodeId, toNodeId) {
		return $http.post("/mastertools/moveuserdata/perform", {
			email: email,
			fromNodeId: fromNodeId,
			toNodeId: toNodeId,
		}).then(resolveRes);
	}

	function moveExam(examId, fromStudentId, toStudentId) {
		return $http.post("/mastertools/moveexam", {
			exam: examId,
			fromStudent: fromStudentId,
			toStudent: toStudentId,
		}).then(resolveRes);
	}

	function changeExamState(examId, studentId, examState) {
		return $http.post("/mastertools/changeexam/state", {
			exam: examId,
			student: studentId,
			state: examState,
		}).then(resolveRes);
	}

	function resolveRes(response) {
		if (!response.data) {
			var error = new Error("`response.data` was `null`");
			Raven.captureException(error, {
				extra: {
					response: response,
				},
			});
		}
		return response.data;
	}

	return {
		info: info,
		perform: perform,
		moveExam: moveExam,
		changeExamState: changeExamState,
	};
});

